import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import ExhibitorListPage from '@/views/ExhibitorListPage.vue';
import ExhibitorInfoPage from '@/views/ExhibitorInfoPage.vue';
import HomePage from '@/views/HomePage.vue';
import ParticipantInfoPage from '@/views/ParticipantInfoPage.vue';
import RewardPage from '@/views/RewardPage.vue';
import Announcement01Page from '@/views/Announcement01Page.vue';
import Announcement02Page from '@/views/Announcement02Page.vue';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/exhibitor-list',
    name: 'ExhibitorList',
    component: ExhibitorListPage,
  },
  {
    path: '/exhibitor-info',
    name: 'ExhibitorInfo',
    component: ExhibitorInfoPage,
  },
  {
    path: '/participant-info',
    name: 'ParticipantInfo',
    component: ParticipantInfoPage,
  },
  {
    path: '/reward20200726',
    name: 'Reward',
    component: RewardPage,
  },
  {
    path: '/announcement01',
    name: 'Announcement01',
    component: Announcement01Page,
  },
  {
    path: '/announcement02',
    name: 'Announcement02',
    component: Announcement02Page,
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.VUE_APP_BASE_URL,
  routes,
});

export default router;
